import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const removeOauthAuthorizationReducer = createReducer<State, Actions>(initialState, {
  [actions.removeOauthAuthorization.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.removeOauthAuthorization.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.removeOauthAuthorization.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.removeOauthAuthorization.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default removeOauthAuthorizationReducer;
